/** Split a comma-or-pipe delimited string into trimmed non-empty tokens. */
export function splitTags(raw: string | null | undefined): string[] {
  if (!raw || !raw.trim()) return [];
  return raw.split(/[,|]/).map((t) => t.trim()).filter(Boolean);
}

/** Strip leading bullets/numbers a trainer might type: "1.", "1)", "-", "•", "*", "·" */
export function stripLeadingBullet(line: string): string {
  return line
    .replace(/^\d+[.)]\s*/, '')
    .replace(/^[-•*·]\s*/, '')
    .trim();
}

/**
 * Every non-empty line = one step. Leading bullets/numbers are stripped so the
 * drawer's own counters are always the single source of truth.
 */
export function parseDescription(description: string | null | undefined): string[] {
  if (!description) return [];
  return description
    .split('\n')
    .map((l) => stripLeadingBullet(l.trim()))
    .filter(Boolean);
}

/** Non-empty steps only; dual-write description for DB backward compatibility. */
export function stepsToDescription(steps: string[]): string {
  return steps.map((s) => s.trim()).filter(Boolean).join('\n');
}

/**
 * Ordered execution steps for UI: **`description` lines win** when non-empty after parse;
 * otherwise fall back to structured `steps` from DB (legacy / future use).
 */
export function getExecutionStepsForDisplay(
  description: string | null | undefined,
  steps: string[] | null | undefined,
): string[] {
  const fromDesc = parseDescription(description);
  if (fromDesc.length > 0) return fromDesc;
  if (Array.isArray(steps) && steps.length > 0) return steps;
  return [];
}
